import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import logo from '../assets/img/logo.png';
import { login } from '../services/loginServices';
import { myRole } from '../services/roleServices';
import { FaEye, FaEyeSlash } from 'react-icons/fa';


function Login() {
  const [form, setForm] = useState({
    username: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});
  const [errorMsg, setErrorMsg] = useState(''); // ✨ New
  const[showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!form.username ) {
      if (!errors.username) newErrors.username = "Username is required";
    }
    if (!form.password) newErrors.password = "Password is required";  

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
    setErrors({});
    setErrorMsg(''); // Clear error on input change
  };

  const submit = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  // ❌ stop loader if validation fails
  if (!validateForm()) {
    return;
  }

  setLoading(true);
  setErrorMsg("");

  try {
    const response = await login(form);

    if (response?.token) {
      localStorage.setItem("token", response.token);
      localStorage.setItem("role", response.role);

      if (response.role === "event") {
        localStorage.setItem("sub_domain", form.username);
      }

      if (myRole() === "admin") {
        window.location.href = "/adminDashboard";
      } else if (myRole() === "event") {
        window.location.href = "/dashboard";
      } else if (myRole() === "finance") {
        window.location.href = "/revenue";
      } else if (myRole() === "management") {
        window.location.href = "/mgmtdashboard";
      } 
      
    } else if (response?.error) {
      setErrorMsg(response.error);
    }
  } catch (error) {
    console.error("Login error:", error);
    setErrorMsg("Something went wrong. Please try again.");
  } finally {
    setLoading(false); // ✅ always stop loader
  }
  }

  return (
    <div data-theme="default" data-layout="fluid" data-sidebar-position="left" data-sidebar-layout="default">
      <main className="d-flex w-100 h-100 bg-dark">
        <div className="container d-flex flex-column">
          <div className="row vh-100">
            <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center mt-4">
                  <img className="pb-4" src={logo} width="280px" alt="Scientex Conferences" />
                </div>
                {errorMsg && (
                  <div className="alert alert-danger mt-3 p-3" role="alert">
                    {errorMsg}
                  </div>
                )}
                <div className="card">
                  <div className="card-body">
                    <div className="m-sm-3">
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label className='form-label fw-600'>UserName <span className='text-danger'>*</span></Form.Label>
                          <Form.Control
                            type="text"
                            name="username"
                            value={form.username}
                            onChange={handleChange}
                            placeholder="Enter your username"
                            isInvalid={!!errors.username}
                          />
                           <Form.Control.Feedback type="invalid">{errors.username}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='form-label fw-600'>Password <span className='text-danger'>*</span></Form.Label>
                          <Form.Control
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            isInvalid={!!errors.password}
                            className="position-relative"
                          />
                          <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>

                          <span
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: 'absolute',
                            top: '54%',
                            right: '10%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2,
                          }}
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </span>
                        
                          <small>
                            <p className='mt-2 fs-5'> <span className='text-danger fs-5'>*</span> Contact Admin for Password Reset</p>
                          </small>
                        </Form.Group>

                        {/* <div className="d-grid gap-2 mt-3">
                          <button className="btn btn-lg btn-primary" onClick={submit}>
                            Sign in
                          </button>
                        </div> */}
                        <div className="d-grid gap-2 mt-3">
                      <button
                        className="btn btn-lg btn-primary d-flex align-items-center justify-content-center"
                        onClick={submit}
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Signing in...
                          </>
                        ) : (
                          "Sign in"
                        )}
                      </button>
                      </div>
                      </Form>
                    </div>
                  </div>
                </div>

                <div className="text-center mb-3">
                  Welcome to Scientex Conferences Admin Portal
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Login;